import URLParser from '../tools/URLParser';

export default class Plyr {

	constructor() {

		$('.video-player').each((aIndex, aElement) => {

			let element = $(aElement);
			let autoplay = parseInt(element.data('autoplay')) === 1;
			let style = element.data('style');
			let modalAutoplay = false;
			let videoElement = element.find('VIDEO');
			let embedElement = element.find('.plyr__video-embed');

			let selectedElement = null;

			if(videoElement.length>0){
				selectedElement = videoElement;
			}

			if(embedElement.length>0){
				selectedElement = embedElement;
			}

			if (autoplay && style !== 'Inline') {
				autoplay = false;
				modalAutoplay = true;
			}

			let player = new window.Plyr(selectedElement, {
				debug: false,
				controls: [
					//'play-large',
					'play',
					'progress',
					//'current-time',
					//'mute',
					//'volume',
					'captions',
					'settings',
					//'pip',
					//'airplay',
					'fullscreen'
				],
				settings : [
					'captions',
					'quality',
					'speed',
					//'loop'
				],
				storage: {
					enabled: false
				},
				showPosterOnEnd: true,
				autoplay: autoplay
			});

			//debug
			window.player = player;

			// modals
			element.find('.modal.modal-video').each((aIndex, aElement) => {

				let modal = $(aElement);

				modal.on('show.bs.modal', (event) => {

					if (modalAutoplay) {
						player.play();
					}

				});

				modal.on('hide.bs.modal', (event) => {
					player.pause();
				});

			});

		});

	}

}